import { Field } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { globalMessages } from '../../../shared/global-message';

/** Static dropdown options for payment method type selection. */
export const PAYMENT_METHOD_OPTIONS: any[] = [
  {
    caption: globalMessages.captionCreditDebitCard,
    id: globalMessages.collectionMethodEFTC,
    value: globalMessages.collectionMethodEFTC,
  },
  {
    caption: globalMessages.captionBankAccount,
    id: globalMessages.collectionMethodEFT,
    value: globalMessages.collectionMethodEFT,
  },
];

/** Static dropdown options for expiration month. */
export const MONTH_OPTIONS: any[] = Array.from({ length: 12 }, (_, i) => ({
  caption: String(i + 1).padStart(2, '0'),
  id: String(i + 1),
  value: String(i + 1),
}));

/** Factory to create a new Field instance with common defaults. */
export function createField(
  name: string,
  type: string,
  overrides: Partial<ConstructorParameters<typeof Field>[0]> = {}
): Field {
  return new Field({
    name,
    type,
    id: name,
    required: false,
    value: '',
    ...overrides,
  });
}

/** Pre-built field configurations for the payment method form. */
export function createPaymentMethodFields() {
  return {
    paymentMethodField: createField('payment_methods', 'card_image', {
      options: { optionsList: PAYMENT_METHOD_OPTIONS },
    }),
    differentBillingAddrToggle: createField('differentBillingAddrToggle', 'toggle_switch', {
      caption: globalMessages.captionDifferentBillingAddress,
      hintText: 'yes',
      value: false,
    }),
    billingAddress: createField('billingAddress', 'address', {
      caption: globalMessages.captionBillingAddress,
      required: true,
    }),
    policyHolderCheckboxField: createField('policyHolderCheckbox', 'checkbox', {
      caption: globalMessages.captionUsePolicyholderName,
      value: false,
    }),
    cardHolderNameField: createField('cardHolderName', 'text', {
      caption: globalMessages.captionCardholderName,
      required: true,
    }),
    accountHolderNameField: createField('accountHolderName', 'text', {
      caption: globalMessages.captionAccountHolderName,
      required: true,
    }),
    cardNumberField: createField('cardNumber', 'text', {
      caption: globalMessages.captionCardNumber,
      required: true,
      disabled: true,
    }),
    expirationMonthField: createField('expirationMonth', 'dropdown', {
      caption: globalMessages.captionExpirationMonth,
      required: true,
      min: 1,
      max: 12,
      options: { optionsList: MONTH_OPTIONS },
    }),
    expirationYearField: createField('expirationYear', 'number', {
      caption: globalMessages.captionExpirationYear,
      required: true,
    }),
    defaultPaymentCheckboxField: createField('defaultPaymentCheckbox', 'checkbox', {
      caption: globalMessages.captionDefaultPaymentMethod,
      value: false,
    }),
    autoEnrollPayField: createField('autoEnroll', 'checkbox', {
      caption: globalMessages.autoPayEnrollCaption,
      hintText: 'yes',
      icon_path: globalMessages.toggleIconPath,
      value: false,
      disabled: true,
      description: globalMessages.autoPayEnrollDescription,
    }),
    saveCardField: createField('saveCard', 'radio', {
      name: 'saveCard',
      value: '',
      type: 'radio',
      required: true,
      id: 'saveCard',
      caption: 'Do you want to save this for future payments?',
      options: {
        optionsList: [
          createField('saveCard', 'radio', {
            value: 'Yes',
            caption: 'Yes',
            id: 'saveCardYes',
            action: "navigate"
          }),
          createField('saveCard', 'radio', {
            value: 'No',
            caption: 'No',
            id: 'saveCardNo',
            action: "navigate"
          }),
        ],
      },
    }),
  };
}
